import { atom } from "recoil"

export const organizationDetailRequestIdState = atom<number>({
  key: "atoms/organization/organizationDetailRequestIdState",
  default: 0,
})
